import {ProductInterface} from "../interfaces/catalog/ProductInterface";

export const RELATION_PRODUCT_TYPE_LABELS: Record<number, string> = {
    1: 'Связанные товары',
    2: 'С этим товаром также покупают',
    3: 'Аналоги',
    4: 'Можно также использовать',
    5: 'Замена',
};

export type RelationProductGroup = {
    typeId: number
    label: string
    products: ProductInterface[]
}

export function groupRelationProductsByType(products: ProductInterface[]): RelationProductGroup[] {
    const groups = new Map<number, ProductInterface[]>();

    products.forEach(product => {
        const typeId = product.link_type_id ?? 1;
        if (!groups.has(typeId)) {
            groups.set(typeId, []);
        }
        const typeProducts = groups.get(typeId) ?? [];
        if (!typeProducts.some(item => item.id === product.id)) {
            typeProducts.push(product);
        }
    });

    return Array.from(groups.entries())
        .sort(([typeA], [typeB]) => typeA - typeB)
        .map(([typeId, groupProducts]) => ({
            typeId,
            label: RELATION_PRODUCT_TYPE_LABELS[typeId] ?? 'Связанные товары',
            products: groupProducts,
        }));
}
